module.exports = __webpack_public_path__ + "static/media/UniversLTStd-Light.87f81056.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/UniversLTStd-Light.woff
// module id = 76
// module chunks = 0